/**
 * PROTOTYPE host page -- THROWAWAY.
 *
 * Master / detail (variant B) won the layout review; variants A (accordion) and
 * C (wizard) were deleted. B's logic is now rewritten properly into the real
 * ProductSelector. This page is kept only as a reference render of the chosen
 * layout while the remaining modules are migrated.
 */
import React, { useState } from 'react';
import { ProjectState, initialProject, CRC } from './moduleInputsData';
import { VariantMasterDetail } from './VariantMasterDetail';

const ModuleInputsPrototype: React.FC = () => {
  const [project, setProject] = useState<ProjectState>(initialProject);

  return (
    <div style={{ background: CRC.pageBg, minHeight: '100%', fontFamily: 'Montserrat, sans-serif' }}>
      <VariantMasterDetail project={project} setProject={setProject} />
    </div>
  );
};

export default ModuleInputsPrototype;
